var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { lighten, IconButton, Tooltip } from "@mui/material";
import { COLORS } from "../../../../../constants";
var toolTipStyles = {
    ".MuiTooltip-popper": {
        ".MuiTooltip-tooltip": {
            "&.MuiTooltip-tooltipPlacementBottom": {
                marginTop: 0,
            },
        },
    },
};
var iconStyles = {
    color: function (theme) { return lighten(theme.palette.primary.main, 0.13); },
    "&.Mui-disabled": {
        color: lighten(COLORS.BLACK, 0.7),
    },
};
/* istanbul ignore next */
var ActionIcon = function (_a) {
    var active = _a.active, action = _a.action, children = _a.children, _b = _a.tooltip, tooltip = _b === void 0 ? "" : _b, sx = _a.sx, rest = __rest(_a, ["active", "action", "children", "tooltip", "sx"]);
    return (_jsx(Tooltip, __assign({ title: tooltip, sx: toolTipStyles }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ onClick: action, disabled: !active, size: "small", sx: __assign(__assign({}, iconStyles), sx) }, rest, { children: children })) }) })));
};
export default ActionIcon;
